module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10262.67c4efc7.jpg";